export { AccordionGallery } from './accordion-gallery.component'
